module.exports = __webpack_public_path__ + "static/media/loading1.97976b0d.gif";